  jQuery(document).ready(function () {

  jQuery("#iamclick").on("click", function (e) {
    //console.log('hello click');
    jQuery(".cardnumber-response").text("Processing, Please wait!");
    var cardnumber = jQuery(".cardnumber").val();
    var url = window.location.origin;
    e.preventDefault();
    // Get Current Cart Data
    jQuery.getJSON("/cart.js", function (cart) {
      var app_url =
        "https://shortsbrewing.localgiftcards.net/web/index.php/smarttransaction";
      // get the order total
      var checkout_total = $("#data-subtotal-amount")
        .text()
        .replace("$", "")
        .replace(",", "");
      var checkout_total = checkout_total.match(/[0-9.]+/g);

      console.log("cdcd " + checkout_total);
      // var checkout_total = parseFloat(checkout_total) + parseFloat(7.99);
      var checkout_total = parseFloat(checkout_total);
      jQuery.ajax({
        type: "post",
        dataType: "json",
        url: app_url + "/smarttransactionprocessing",
        crossDomain: true,
        data: {
          cardnumber: cardnumber,
          site_url: url,
          cartAmount: checkout_total,
          cart_id: cart.token,
        },
        success: function (res) {
          if (res.status == "success_insufficient") {
            jQuery.post("/cart/add.js", {
              items: [
                {
                  quantity: 1,
                  id: res.variant,
                },
              ],
            });
            jQuery(".cardnumber-response_success").text(res.info);
            jQuery(".cardnumber-response_success").addClass("insufficient");
            jQuery(".cardnumber-response_success").css("display", "block");
            jQuery("input[name='discount']").val(res.code);
            jQuery(".cardnumber-response").html("");

          } else if (res.status == "success") {
            console.log("ENTERRRRRRRR: ", res.code);
            jQuery(".cardnumber-response_success").css("display", "block");
            jQuery(".cardnumber-response_success").text(res.info);
            // jQuery('.offer_discount').val(res.code);
            jQuery("input[name='discount']").val(res.code);
            jQuery(".cardnumber-response").html("");
            
          } else {
            jQuery(".cardnumber-response_success").css("display", "none");
            if (res.mes == undefined) {
              jQuery(".cardnumber-response").html(
                '<span style="color:red">Please try later.</span>',
              );
            } else {
              jQuery(".cardnumber-response").html(
                '<span style="color:red">' + res.mes + "</span>",
              );
            }
          }
        },
        error: function (err) {
          console.log("error: " + err);
          jQuery(".cardnumber-response_success").css("display", "none");
          if (err.mes == undefined) {
            jQuery(".cardnumber-response").html(
              '<span style="color:red">Please try later.</span>',
            );
          } else {
            jQuery(".cardnumber-response").html(
              '<span style="color:red">' + err.mes + "</span>",
            );
          }
        },
      });
    });
  });
  });
  
document.addEventListener("submit", function (e) {
    var form = e.target;

    var btn = e.submitter;

    var discount = jQuery("input[name='discount']").val();

    if (discount) {
      if (form.action && form.action.includes("/cart") && btn.id == "checkout") {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "discount";
        input.value = discount;
        form.appendChild(input);
      }
    }
  },
  true,
);
